import { takeEvery, call, put, all, select } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import {
    LOAD_VIDEOLISTS_ALL_BY_ID,
    loading, putVideolistsAll,
    putVideolistsAllSongs,
    toggleVideolistsAllSongs
} from '../../store/ContentAllVideolists/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'

export default function* () {
    yield takeEvery(LOAD_VIDEOLISTS_ALL_BY_ID, worker)
}

function* worker({ payload }) {

    yield put(toggleVideolistsAllSongs(true))

    try {

        let selected = yield select(state => state.videolists_all.selected);


        if (!selected[0]) {
            return
        }

        if (!payload) {
            payload = {}
        }

        if (!payload.offset) {
            yield put(putVideolistsAllSongs([]))

        }

        let list = yield select(state => state.videolists_all.songs)

        yield put(loading(true))

        payload.playlist_id = selected[0]


        let videolists = yield select(state => state.videolists_all.allVideolists);
        let public_tracks_table = yield select(state => state.videolists.assocPublicTracksTable)
        const search_name = yield select(state => state.search.songs.value)

        if (payload.offset)
            payload.offset = list.length;
        else
            payload.offset = 0;


        let search_params = { ...payload }

        let searchName;
        if (payload && 'name' in payload) {
            searchName = payload?.name
        } else {
            searchName = search_name || ''
        }

        if (searchName && searchName !== '') {
            search_params.query = searchName
            delete search_params?.name;
        }

        if (!!!(search_params.name)) {
            delete search_params.name
        }

        if (public_tracks_table.sort_field) {
            search_params[`sort[${[public_tracks_table.sort_field]}]`] = public_tracks_table.sort_dir;
        }


        const fetchedVideolist = yield call(fetchClips, search_params)

        if (fetchedVideolist.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${LOAD_VIDEOLISTS_ALL_BY_ID}.`, fetchedVideolist],
                text: "Ролики не были загружены. Попробуйте перезагрузить страницу."
            }))
            //yield put(putVideolistsAll({ videolists }))

        } else {

            let songsMap = payload?.offset ? [...list] : [];
            console.log({ songsMap }, fetchedVideolist.success.length);


            const songs = fetchedVideolist.success.map(track => {
                track.filename = buildGETUrl("clip/play", { id: track.id })
                songsMap.push(track);
                return track
            })
            videolists = videolists.map(list => {
                if (list.id === selected[0]) {
                    list.songs = songs
                    list.songsMap = songsMap

                }
                return list;
            })

            yield put(putVideolistsAllSongs(songsMap))
            yield put(putVideolistsAll({ videolists }))
        }
    } catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${LOAD_VIDEOLISTS_ALL_BY_ID}.`, e],
            text: "Плейлисты не были загружены. Попробуйте перезагрузить страницу."
        }))
        yield put(putVideolistsAllSongs([]))
        yield put(putVideolistsAll({ videolists: [] }))
    } finally {
        yield put(loading(false))
        yield put(toggleVideolistsAllSongs(false))

    }
}



function fetchClips(params) {

    return axios.get(`/videolist/tracks/search`, {
        params: {
            ...params,
            limit: 50

        }
    })
        .then(response => response.data)
}